// @flow
import React from 'react';
import './style.less';

type TProps = {
    children: any,
    className?: string,
    size?: 'small' | 'middle' | 'big' | 'bigg' | 'bigger' | 'biggest' | 'scale',
    theme?: 'white' | 'blue' | 'yellow' | 'light-blue' | 'red' | 'green' | 'gray' | 'light-gray' | 'darkest-gray' | 'black' | 'kasper',
    weight?: 'bold' | 'normal',
};

const TextComponent = ({size = 'small', weight = 'normal', theme = 'white', children, className, ...rest}: TProps, ref) => {
    return (
        <span
            className={`label-text label-text_weight_${weight} label-text_size_${size} label-text_theme_${theme}  ${className ? className : ''}`}
            ref={ref}
            {...rest}
        >
            {children}
        </span>
    );
};

const LabelText = React.forwardRef(TextComponent);

export {LabelText};
